import { lazy } from 'react';

const ExpenseDaily = lazy(() => import('./ExpenseDaily'));
const BudgetCategory = lazy(() => import('./BudgetCategory'));
const BudgetBoard = lazy(() => import('./BudgetBoard'));
const PayeeManage = lazy(() => import('./PayeeManage'));
const CompanyBankAccounts = lazy(() => import('./CompanyBankAccounts'));
const BankBranches = lazy(() => import('../HR/BankBranch/BankBranches'));

export const expensePageRoutes = [
  { path: '/expense/daily', component: ExpenseDaily },
  { path: '/expense/payees', component: PayeeManage },
  { path: '/expense/company-bank-accounts', component: CompanyBankAccounts },
  { path: '/expense/bank-branches', component: BankBranches },
  { path: '/expense/budget/categories', component: BudgetCategory },
  { path: '/expense/budget/board', component: BudgetBoard }
];
